import type { SwiperBreakpoints } from '@uefadigital/panenka';

import type { EditorialContent } from '@shared-types/editorial.types';
import type { Enum } from '@shared-types/enum.types';
import type { Bucket, BucketType, PlaylistItem, UefatvEditorialContent } from '@shared-types/uefatv.types';

/**
 * Item expected by the uefatv carousel component.
 * @property {string} id - The unique identifier for the carousel item.
 * @property {string} title - The title of the carousel item.
 * @property {EditorialContent[]} items - The list of editorial content items associated with the carousel item.
 */
export type CarouselItem = {
  id: string;
  title: string;
  description?: string;
  type: BucketType;
  items: EditorialContent[];
};

export const CardFormat = {
  WIDE: 'wide',
  SQUARE: 'square',
  PORTRAIT: 'portrait',
} as const;
export type CardFormat = Enum<typeof CardFormat>;

export type CarouselLayout = {
  staticFirstSlide?: boolean;
  breakpoints?: SwiperBreakpoints;
  cardLayout?: CardLayout;
  cardsForColumn?: number;
};
export type CardLayout = {
  cardFormat?: CardFormat;
  content?: 'default' | 'over';
  orientation?: 'portrait' | 'horizontal';
  hideDescription?: boolean;
  transparency?: boolean;
};

export const UefaTvBusEvents = {
  TOKEN_CHANGED: 'uefatv-token-changed',
} as const;
export type UefaTvBusEvents = Enum<typeof UefaTvBusEvents>;

export type BucketContainer = Bucket & {
  items: UefatvEditorialContent[];
};

export type PlayListContainer = PlaylistItem & {
  items: UefatvEditorialContent[];
};
